
import * as React from 'react'
import style from './style.module.css'

let bridge: {
  setMsg?: (msg: string) => any
} = {}

// 暴露给用户调用的方法
export function alert(msg: string) {
  if (bridge.setMsg) {
    bridge.setMsg(msg)
  }
}

export function WeikeAlertDemo() {
  // 初始化组件内部数据
  const [msg, setMsg] = React.useState<string | null>(null)

  // 通过一个 bridge 对象在组件初始化的时候，把内部方法暴露到外部
  React.useEffect(() => {
    bridge.setMsg = setMsg
  }, [])

  const handleClick = React.useCallback(() => setMsg(null), [])
  if (msg) {
    return (
      <div className={style['alert-content']} id='weike-ui-alert'>
        <div>提示</div>
        <div>{msg}</div>
        <div><button onClick={handleClick}>确定</button></div>
      </div>
    )
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ../src/popup-layer/alert/index.tsx